import React from 'react';

const STATUS_TABS = [
  { value: 'all',         label: 'All'         },
  { value: 'pending',     label: 'Pending'     },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'completed',   label: 'Completed'   },
];

export default function TaskFilters({
  statusFilter,   onStatusChange,
  priorityFilter, onPriorityChange,
  assigneeFilter, onAssigneeChange,
  staff, isAdmin,
}) {
  return (
    <div className="tasks-filters">
      {/* Status tabs */}
      <div className="tasks-filters__tabs">
        {STATUS_TABS.map(({ value, label }) => (
          <button
            key={value}
            className={`tasks-filters__tab${statusFilter === value ? ' tasks-filters__tab--active' : ''}`}
            onClick={() => onStatusChange(value)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Priority + assignee selects */}
      <div className="tasks-filters__right">
        <select
          className="tasks-filters__select"
          value={priorityFilter}
          onChange={e => onPriorityChange(e.target.value)}
        >
          <option value="all">All Priorities</option>
          <option value="urgent">🔴 Urgent</option>
          <option value="high">🟠 High</option>
          <option value="medium">🟡 Medium</option>
          <option value="low">⚪ Low</option>
        </select>

        {isAdmin && (
          <select
            className="tasks-filters__select"
            value={assigneeFilter}
            onChange={e => onAssigneeChange(e.target.value)}
          >
            <option value="all">All Employees</option>
            {staff.map(s => (
              <option key={s.uid} value={s.uid}>{s.name}</option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}
